module.exports = "../../static/fonts/Lato-Italic.56c4cb2.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-Italic.ttf
// module id = 917
// module chunks = 2